import { userListApi } from "../../api/user/userListApi"
import { User } from "../../entities/user"

type PayloadShape = Parameters<typeof userListApi>[0]

export async function userListService(payload: PayloadShape, token?: null | string) {
	const user = await userListApi(payload, token)
	return user as NonNullable<User[]>
}
